import { StringAdapter } from "../StringAdapter";

import { ColumnDefinition } from "../../model/ColumnDefinition";

import { IRateSourceLookupService } from "../../lookup/model/IRateSourceLookupService";

export class RateSourceAdapter extends StringAdapter {
  private rateSourceLookup: IRateSourceLookupService;
  constructor(rateSourceLookup: IRateSourceLookupService) {
    super();
    this.rateSourceLookup = rateSourceLookup;
  }

  retrieveData(order: any, columnProperty: string): string {
    if (this.rateSourceLookup) {
      // RateSourceImpl
      var rs = this.rateSourceLookup.getRateSource(order[columnProperty]);
      if (rs) {
        return rs.description;
      }
    }
    return "-";
  }
}
